export default __webpack_public_path__ + "static/port3-61a6ce370e0f5cc5225e27bcaaa17045.jpg";